import { AutodeskViewer } from "../components/autodeskViewer";
import { ISpaceOnMap } from "../interfaces";
export class StyleManager {
	public constructor(private autodeskViewer: AutodeskViewer) {
	}

	public applyStyles(model: Autodesk.Viewing.Model, spaces: ISpaceOnMap[]): void {
		const spacesWithStyles = spaces.filter((space) => space.style);
		spacesWithStyles.forEach((space) => this.applyStyle(model, space));
	}

	public cleanStyles(): void {
		const visibleModels = this.autodeskViewer.viewer.getVisibleModels();

		if (visibleModels != null) {
			try {
				visibleModels.forEach((model) => this.autodeskViewer.viewer.clearThemingColors(model));
			} catch (error) {
				console.error(`cannot clear autodesk theming colors`, error);
			}
		}
	}

	private applyStyle(model: Autodesk.Viewing.Model, space: ISpaceOnMap): void {
		const placeStyle = space.style?.placeStyle;
		if (placeStyle) {
			const color = new THREE.Color(placeStyle.fillColor);
			this.autodeskViewer.viewer.setThemingColor(space.dbId, new THREE.Vector4(color.r, color.g, color.b, placeStyle.fillOpacity), model);
		}
	}
}
